import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { UserPermissions } from '../../../../lib/constants/user-permissions';
import { MortgageApplicationContext } from '../../models/mortgage-application-context.model';
import { MortgageApplicationFormService } from '../../services/mortgage-application-form.service';
import { BaseSaveSectionComponent } from '../base-save-section.component';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';
import { MortgageApplicationService } from './../../services/mortgage-application.service';

@Component({
  selector: 'boi-save-application',
  templateUrl: './save-application.component.html',
  styleUrls: ['./save-application.component.scss']
})
export class SaveApplicationComponent extends BaseSaveSectionComponent implements OnDestroy, OnInit {
  public userPermissions = UserPermissions;
  public isActionVisible: boolean;

  @Input() public hideActionButton = false;
  @Output() public readonly save = new EventEmitter<any>();
  @Output() public readonly cancel = new EventEmitter<any>();

  constructor(
    protected readonly mortgageApplicationStore: MortgageApplicationStore,
    protected readonly mortgageApplicationService: MortgageApplicationService,
    protected readonly router: Router,
    public readonly route: ActivatedRoute,
    private readonly mortgageApplicationFormService: MortgageApplicationFormService
  ) {
    super(mortgageApplicationStore, mortgageApplicationService, router, route);
  }

  ngOnInit(): void {
    this.isActionVisible =
      !this.hideActionButton &&
      !(
        this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity.IsFactFindReadOnly &&
        this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity.isBranchApplication &&
        this.mortgageApplicationFormService.getCurrentContext() === MortgageApplicationContext.Internal
      );
  }

  public saveApplication(): void {
    this.mortgageApplicationService.prepareDataForSave(
      this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity
    );

    this.mortgageApplicationService
      .saveMortgageApplication(this.mortgageApplicationStore.mortgageApplicationResponse.mortgageApplicationEntity)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data) => {
        this.mortgageApplicationStore.mortgageApplicationResponse = data;
        this.save.emit();
      });
  }
}
